export const getDate = (date) => {
  const dateStr = date.split(",");
  const secondDate = dateStr[0].split("/");
  return new Date(secondDate[2], secondDate[1] - 1, secondDate[0]);
};
